import { render, staticRenderFns } from "./medicion-mortalidad-editar.vue?vue&type=template&id=3bcea2ba&scoped=true&"
import script from "./medicion-mortalidad-editar.vue?vue&type=script&lang=js&"
export * from "./medicion-mortalidad-editar.vue?vue&type=script&lang=js&"
import style0 from "./medicion-mortalidad-editar.vue?vue&type=style&index=0&id=3bcea2ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcea2ba",
  null
  
)

export default component.exports